import * as yup from 'yup'
import FulfillmentItem from './FulfillmentItem'

type Fulfillment = {
  orderId?: string
  fulfillmentNumber?: number
  fulfillmentType: string
  fulfillAt?: string
  name?: string
  service?: string
  shipmentStatus?: string
  status?: string
  trackingNumbers?: string
  fulfillmentItems: {create: FulfillmentItem[]}
  shippingDefinition?: any
  order?: any
  tracking?: any
  shippingPrice?: number
  carrierServiceProviderId?: string
  locationId?: string
}

export type CarrierFulfillment = {
  orderId?: string
  fulfillmentType: string
  fulfillAt?: string
  status?: string
  trackingNumbers?: string
  shippingDefinition?: any
  tracking?: any
  shippingPrice?: number
  locationId?: string
}

export default Fulfillment

export const ShippingDefinitionSchema = yup.object().shape({
  labelType: yup.string().required('Please select label size'),
  imageType: yup.string().required('Please select image type'),
  deliveryMethod: yup.object().shape({
    rate: yup.number().required('Please select delivery method'),
  }),
  package: yup.object().shape({
    id: yup.string().required('Please select package'),
  }),
  weight: yup.object().shape({
    value: yup
      .number()
      .min(0.1, 'Package weight must be greater than 0 lbs')
      .max(150, 'Package weight must be less than 150 lbs'),
  }),
})
